import {
  Box,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  useColorModeValue,
  useMediaQuery,
  VStack,
} from "@chakra-ui/react";
import { BiUser } from "react-icons/all";
import styled from "@emotion/styled";

import { useWindowDimension } from "utils/hooks/useWindowDimension";

import { UndrawImage } from "components/UndrawImage";
import { ChakraText } from "components/ChakraText";
import { Icon } from "components/Icon";
import { useGetThemeColors } from "ChakraTheme";

import calendar from "assets/undraw_Calendar.svg";
import calendar_dark from "assets/undraw_Calendar_dark.svg";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const MobileAuthenticationDropdown = ({ children }: IProps) => {
  const [isSmallHeight] = useMediaQuery("(max-height: 550px)");
  const { height } = useWindowDimension();

  return (
    <Box ml={4}>
      <Menu>
        <MobileAuthenticationMenuButton />
        <MenuList>
          <StyledBox
            height={isSmallHeight ? `${height - 100}px` : "auto"}
            overflowY="scroll"
          >
            <Box p={6}>
              <UndrawImage
                maxH="200px"
                lightImage={calendar}
                darkImage={calendar_dark}
                alt="Kalendarz"
              />
            </Box>
            <VStack>
              <ChakraText fontWeight="bold">Witamy w e-Rezerwacji!</ChakraText>
              {children}
            </VStack>
          </StyledBox>
        </MenuList>
      </Menu>
    </Box>
  );
};

const MobileAuthenticationMenuButton = () => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.black, colors.white);
  const backgroundHoverColor = useColorModeValue(
    colors.gray[200],
    colors.gray[500]
  );
  return (
    <MenuButton
      px={4}
      py={2}
      borderRadius={8}
      _hover={{ bg: backgroundHoverColor }}
    >
      <HStack>
        <Icon w={7} h={7} color={iconColor} icon={BiUser} />
      </HStack>
    </MenuButton>
  );
};

const StyledBox = styled(Box)`
  * {
    -ms-overflow-style: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;

export { MobileAuthenticationDropdown };
